type ReviewStatus = "new" | "drafted" | "ready" | "posted" | "skipped" | "needs_review";

const labels: Record<ReviewStatus, string> = {
  new: "New",
  drafted: "Drafted",
  ready: "Ready to post",
  posted: "Posted",
  skipped: "Skipped",
  needs_review: "Needs review",
};

const styles: Record<ReviewStatus, string> = {
  new: "bg-slate-100 text-slate-700 ring-slate-200",
  drafted: "bg-sky-50 text-sky-700 ring-sky-200",
  ready: "bg-amber-50 text-amber-700 ring-amber-200",
  posted: "bg-emerald-50 text-emerald-700 ring-emerald-200",
  skipped: "bg-slate-50 text-slate-500 ring-slate-200",
  needs_review: "bg-rose-50 text-rose-700 ring-rose-200",
};

export function StatusBadge({ status }: { status: ReviewStatus }) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset ${styles[status]}`}
    >
      {labels[status]}
    </span>
  );
}
